import {
  canUpgrade,
  findQuota,
  getQuota,
  hasFeature,
  hasPermission,
  hasQuota,
  isOnFreePlan,
  user,
} from '@/ui/auth/auth';

export default {
  computed: {
    isOnFreePlan: () => isOnFreePlan.value,
    currentUserCount: () => (
      (user.value._legacy_subscription && user.value._legacy_subscription.users.count) || 1
    ),
  },
  methods: {
    hasFeature,
    hasPermission,
    hasQuota,
    getQuota,
    findQuota,
    canUpgrade,
    loggedInUser: () => user.value,
  },
};
